//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'

import colors from 'components/utils/colors'
import IconLink from 'components/Shared/IconLink/Index'
import Badge from 'components/Shared/Badge/Index'

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`

const StyledIconLink = styled(IconLink)`
`

const StyledInfoBadge = styled.div`
  &:hover {
    ${StyledIconLink} {
      &:before {
        color: ${colors.primary40};
      }
    }
  }
`

const CountBadge = styled(Badge)`
  margin 0 1px 0 8px;
  color: ${colors.secondary20};
`


const InfoBadge = ({ children, iconName, tooltip, tooltipId, url }) => {
  if (!children) {
    return null
  }

  return (
    <StyledInfoBadge
      data-tooltip-content={tooltip}
      data-tooltip-id={tooltipId}
    >
      <StyledLink to={url} onClick={e => e.stopPropagation()} data-test='info-badge-link'>
        <StyledIconLink iconName={iconName} />
        <CountBadge color={colors.success73}>
          {children}
        </CountBadge>
      </StyledLink>
    </StyledInfoBadge>
  )
}

InfoBadge.propTypes = {
  children: PropTypes.node,
  iconName: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  url: PropTypes.string.isRequired,
}

export default InfoBadge
